import { Link } from "react-router-dom";
import { MapPin, MessageCircle, Instagram, Music2 } from "lucide-react";
import { Monogram } from "./BrandGraphics";

const IG = "mua.dessywedding";
const TT = "dessyweddinggarut.mua";
const linkCls = "text-[var(--dark-muted)] hover:text-[var(--dark-text)] transition-colors";

export default function PublicFooter({ contact = {} }) {
  const wa = contact.contact_wa || "628112225912";
  const waDisplay = `+${wa.slice(0, 2)} ${wa.slice(2, 5)}-${wa.slice(5, 9)}-${wa.slice(9)}`;
  return (
    <footer className="zone-dark border-t border-[var(--dark-line)]" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 grid gap-10 md:grid-cols-[1.4fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <Monogram size={48} />
            <div>
              <div className="font-serif text-xl font-semibold text-[var(--dark-text)]">Dessy Wedding Group</div>
              <div className="eyebrow !text-[10px]">Est. 2015</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-[var(--dark-muted)] max-w-sm leading-relaxed">
            Wedding organizer, MUA, dekorasi, dokumentasi & attire dalam satu tim — melayani Garut, Bandung, dan sekitarnya.
          </p>
          <div className="mt-4 flex items-center gap-2 text-xs text-[var(--champagne)]"><MapPin className="w-3.5 h-3.5" /> Garut · Bandung · Sekitarnya</div>
        </div>
        <div>
          <div className="eyebrow mb-4">Jelajahi</div>
          <ul className="space-y-2.5 text-sm">
            <li><Link to="/paket-wedding-dwg" className={linkCls} data-testid="footer-link-paket">Paket Wedding DWG</Link></li>
            <li><Link to="/paket-wedding-dwg?q=Intimade" className={linkCls} data-testid="footer-link-intimade">Intimade (50–300 pax)</Link></li>
            <li><Link to="/vendor" className={linkCls} data-testid="footer-link-vendor">Vendor & Harga</Link></li>
            <li><Link to="/consultation" className={linkCls} data-testid="footer-link-consult">Konsultasi Gratis</Link></li>
          </ul>
        </div>
        <div>
          <div className="eyebrow mb-4">Hubungi Kami</div>
          <ul className="space-y-2.5 text-sm">
            <li><a href={`https://wa.me/${wa}`} target="_blank" rel="noreferrer" className={`${linkCls} flex items-center gap-2`} data-testid="footer-wa"><MessageCircle className="w-4 h-4 text-[var(--champagne)]" />{waDisplay}</a></li>
            <li><a href={`https://instagram.com/${IG}`} target="_blank" rel="noreferrer" className={`${linkCls} flex items-center gap-2`} data-testid="footer-ig"><Instagram className="w-4 h-4 text-[var(--champagne)]" />@{IG}</a></li>
            <li><a href={`https://www.tiktok.com/@${TT}`} target="_blank" rel="noreferrer" className={`${linkCls} flex items-center gap-2`} data-testid="footer-tiktok"><Music2 className="w-4 h-4 text-[var(--champagne)]" />@{TT}</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-[var(--dark-line)]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-5 flex flex-wrap items-center justify-between gap-3 text-[11px] text-[var(--dark-muted)]">
          <div className="font-serif italic text-sm">© {new Date().getFullYear()} Dessy Wedding Group</div>
          <div className="flex items-center gap-3 uppercase tracking-[0.08em]">
            <Link to="/portal" className="hover:text-[var(--dark-text)]" data-testid="footer-client-portal">Portal Klien</Link>
            <span>·</span>
            <Link to="/login" className="hover:text-[var(--dark-text)]" data-testid="footer-employee-login">Portal Karyawan</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
